import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ReactTypingEffect from 'react-typing-effect';
import ButtonContactGroup from '../../ui/ButtonContactGroup';

gsap.registerPlugin(ScrollTrigger);

const HomePage = React.forwardRef((props, ref) => {
  const elementRef = useRef(null);


  useEffect(() => {
    gsap.fromTo('#welcome',
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, ease: 'power2.out',
        scrollTrigger: {
          trigger: '#welcome',
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      }
    );

    gsap.fromTo('.test-animation',
      { opacity: 0, x: -50 },
      { opacity: 1, x: 0, duration: 1, ease: 'power2.out',
        scrollTrigger: {
          trigger: '.test-animation',
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      }
    );

    gsap.fromTo('.main-title',
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, ease: 'power2.out',
        scrollTrigger: {
          trigger: '.main-title',
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      }
    );

  }, []);

  return (
    <div className='container-fluid gradient-animato'>
      <div className="pb-5 d-block d-md-none"></div>
      <div ref={elementRef} className="container text-end">
        <div ref={ref} className="row min-height-100-y align-items-center justify-content-center pb-5">
          <div className="col-md-12 col-12 flex-column justify-content-center mb-5">
            <div className="text-start mt-5">
              <p className="fw-semibold m-0" id='welcome' style={{ color: '#FFFFF0' }}>Welcome to my website 😁</p>
            </div>
            <div className="text-start">
              <div>
                <b className="fs-5 text-white test-animation">HI I'M A</b>
                <br />
                <h1 className="fw-semibold text-break main-title text-white"> WEB <br />
                  <ReactTypingEffect
                    text={["DEVELOPER", "DESIGNER"]}
                    speed={100}
                    eraseSpeed={50}
                    eraseDelay={2000}
                    typingDelay={500}
                  />
                </h1>
              </div>
            </div>
            <div className="text-start">
              <ButtonContactGroup iconColor={'text-white'} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default HomePage;